import { z } from 'zod';

import { OrderDirection } from '@/constants/orderDirection';

const StarlinkCategory = {
  ACTIVE: 'ACTIVE',
  NOT_ACTIVE: 'NOT_ACTIVE',
  ALL: 'ALL',
} as const;

export const StarlinkTableFilterSchema = z.object({
  orderDirection: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z.string().optional(),
  page: z.number().default(1),
  pageSize: z.number().default(100),

  category: z.nativeEnum(StarlinkCategory).default(StarlinkCategory.ALL),
  freeText: z.string().optional(),
  placeIdIn: z.array(z.string()).optional(),
  fleetIdIn: z.array(z.string()).optional(),
  networkIdIn: z.array(z.string()).optional(),
});
